import React, {  useEffect, useMemo, useRef } from "react";
import { VStack } from "rsuite";
import { useDispatch, useSelector } from "react-redux";

import Header from "components/Header/Header";
import TopHeading from "components/common/TopHeading";
import AllFeedback from "./table-data/TableData"
import Pagination from "components/common/Pagination";

import CustomerProfileAPI from "services/CustomerProfileAPI";
import Filter from "components/common/Filter";
import useFetchWithFilter from "hooks/useFetchWithFilter";
import { useLocation } from "react-router-dom";
import helperInstance from "lib/helper";


export default function Feedback() {
    const {
        data: {
            feedbacks = [],
            totalRows: totalCount = 0,
            totalPages = 0,
        } = {},
        loading,
        fetchWithFilter
    } = useFetchWithFilter();
  const { currentPage } = useSelector((state) => state.pagination);
  const dispatch = useDispatch();
  const location = useLocation();
  const apiInstance = useMemo(() => new CustomerProfileAPI(), []);
  const apiFn = apiInstance.feedbackRequest;
  const filterRef = useRef(null);

  const fetchData = () => {
    fetchWithFilter({
      apiFn,
    });
  }

  useEffect(() => {
    fetchData(true)
  }, [currentPage, location.search, location.state, fetchWithFilter, apiFn]);

  useEffect(() => {
    feedbacks && helperInstance.updatePagination(totalPages, totalCount, dispatch);
  }, [feedbacks, dispatch])


    return (
        <VStack alignItems="stretch" spacing={20}>
            {/* Header */}
            <Header />

            {/*Top Heading */}
            <TopHeading />
            <Filter ref={filterRef} pageName="Loan Feedback" buttonLabel={true}/>

            {/* All Feedback  */}
            <AllFeedback data={feedbacks} loading={loading} clearFilters={filterRef?.current
                ?.clear} />

            {/* Pagination */}
            <Pagination />
        </VStack>
    );
}
